import { useMemo } from 'react'
import dayjs from 'dayjs'
import isEmpty from 'lodash/isEmpty'
import { COOKIE_KEYS, getCookie } from '@features/General'
import { Mixpanel } from '@features/General/handlers/mixPanel'
import useUser from 'hooks/processor/useUser'

// The user is not logged in when we do not have event Id and token, so We user GUID for identifying mixpanel

function useMixpanel() {
    const eventId = getCookie(COOKIE_KEYS.ALA_EVENT)
    // const nonLoggedInUserId = getCookie(COOKIE_KEYS.NON_LOGGED_IN_USER_ID)
    const { contactId } = useUser()
    const loggedIn = useMemo(
        () => eventId && !isEmpty(getCookie(COOKIE_KEYS.ALA_TOKEN)),
        [eventId, COOKIE_KEYS.ALA_TOKEN]
    )
    const setMixPanelData = (contact, onboarding, subscription, outgoingRequestsTotal, incomingRequestsTotal) => {
        Mixpanel.identify(contact._id)
        Mixpanel.track('Successful login', contact)
        const startDate = dayjs(subscription.createdAt, 'YYYY-MM-DD hh:mm AZ')
        const endDate = dayjs(subscription.expiryDate, 'YYYY-MM-DD hh:mm AZ')
        const planType = endDate.diff(startDate, 'years', true) >= 0.9 ? 'Annual' : 'Monthly'
        Mixpanel.people.set({
            $user_id: contact._id,
            $email: contact.email,
            $name: `${contact.firstname} ${contact.lastname}`,
            $phone: contact.mobile,
            'User Type': contact?.roleType,
            'User Country': contact.country?.name || contact.country,
            'User City': contact.city?.name || contact.city,
            'User Has Linkedin Profile': !!contact.linkedin,
            'User Has Twitter Profile': !!contact.twitter,
            // 'User Attended Hubs': ['Meeting', 'WIC Event', 'X Event'],
            'User Completed Onboarding': onboarding.contactOnboarded, // or false
            'User Incoming Meeting Requests': incomingRequestsTotal,
            'User Outgoing Meeting Requests': outgoingRequestsTotal,
            'Company Plan Name': subscription?.subscription?.name,
            'Company Plan Credits': subscription?.remainingPoints || 0,
            'Company Plan User Count': subscription?.maxSubscribers || 0,
            'Company Plan Billing Type': planType,
            'Company Plan Price': subscription?.payment?.paidPrice || 0,
            'Company Plan Appointment Setter Count': 0,
            'Company ID': contact.company,
            'Company Name': contact.companyName,
            'Company Email': contact.companyEmail,
            'Company Phone': contact.companyPhone,
            'Company Country': contact.companyCountry,
            'Company City': contact.companyCity,
            'Company ITP Count': contact.companyItpCount,
            'Company Completed Onboarding': onboarding.companyOnboarded, // or false
            'Company Action List Progress': 100
        })
    }

    const trackData = (type, data = {}, addUserState = false) => {
        if (loggedIn) {
            Mixpanel.identify(contactId)
        }
        // Mixpanel.identify(loggedIn ? contactId : nonLoggedInUserId)
        const values = { ...data }
        if (addUserState) {
            values['User State'] = loggedIn ? 'Logged-In' : 'Not Logged-In'
        }
        Mixpanel.track(type, values)
    }

    return {
        setMixPanelData,
        trackData
    }
}

export default useMixpanel
